import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodSavedFilterResponseSchema } from '../validations';

import {
  type CreateSavedFilterPayload,
  type CreateSavedFilterResponse,
} from './types';

/**
 * Creates a saved filter.
 *
 * Payload keys use camelCase and are converted to the backend contract by the
 * ky case converter.
 *
 * @param payload - Saved-filter data to create.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The created saved filter.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/User/operation/create_saved_filter_user_saved_filters_post
 */
export const createSavedFilter = async (
  payload: CreateSavedFilterPayload,
  options?: KyRequestOptions,
): Promise<CreateSavedFilterResponse> => {
  const response = await vestigasApi
    .post(ENDPOINT.USER.SAVED_FILTERS(), {
      ...options,
      json: payload,
    })
    .json<CreateSavedFilterResponse>();

  const validated = zodSavedFilterResponseSchema.safeParse(response);

  if (!validated.success) {
    console.warn(
      '[createSavedFilter] Response validation failed',
      validated.error,
    );
    return response;
  }

  return validated.data;
};
